const encodedSymbol = Symbol('encodedJSONAttribute');
export type EncodedJSONAttribute<T> = string & { [encodedSymbol]: T };

export const encodeJSONForDataAttribute = <Json extends Record<string, unknown>>(json: Json) => {
    return encodeURIComponent(JSON.stringify(json)) as EncodedJSONAttribute<Json>;
};

export const decodeJSONFromDataAttribute = <Json extends Record<string, unknown>>(encodedJson: EncodedJSONAttribute<Json>) => {
    return JSON.parse(decodeURIComponent(encodedJson)) as Json;
};
